import React, { useState, useEffect } from 'react'
import { CheckCircle, Circle, Sparkles } from 'lucide-react'

const EXTRACTING_STEPS = [
  'Reading document structure…',
  'Locating seller and closing company…',
  'Extracting purchase price and dates…',
  'Cross-referencing Identification Hub…',
]

interface PurchaseAgreementExtractingProps {
  fileName: string
}

export const PurchaseAgreementExtracting: React.FC<PurchaseAgreementExtractingProps> = ({
  fileName,
}) => {
  const [stepIndex, setStepIndex] = useState(0)
  useEffect(() => {
    const timer = setInterval(() => {
      setStepIndex((prev) => Math.min(prev + 1, EXTRACTING_STEPS.length - 1))
    }, 500)
    return () => clearInterval(timer)
  }, [])
  return (
    <div
      className="rounded-xl border border-purple-200 dark:border-purple-700 bg-gradient-to-br from-purple-50 to-indigo-50 dark:from-purple-900/20 dark:to-indigo-900/20 p-5"
      role="status"
      aria-live="polite"
      aria-label="Neela is reading purchase agreement"
      data-testid="purchase-agreement-extracting"
    >
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-purple-100 dark:bg-purple-800/40 flex items-center justify-center">
          <Sparkles
            className="h-5 w-5 text-purple-600 dark:text-purple-400 animate-pulse"
            aria-hidden="true"
          />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-purple-900 dark:text-purple-100 mb-0.5">
            Neela is reading your Purchase Agreement…
          </p>
          <p className="text-xs text-purple-600 dark:text-purple-400 truncate mb-3">{fileName}</p>
          <div className="space-y-1.5">
            {EXTRACTING_STEPS.map((step, index) => (
              <div key={step} className="flex items-center gap-2">
                {index < stepIndex ? (
                  <CheckCircle
                    className="h-3 w-3 text-emerald-500 flex-shrink-0"
                    aria-hidden="true"
                  />
                ) : index === stepIndex ? (
                  <span
                    className="h-3 w-3 rounded-full border-2 border-purple-500 border-t-transparent animate-spin flex-shrink-0"
                    aria-hidden="true"
                  />
                ) : (
                  <Circle
                    className="h-3 w-3 text-purple-300 dark:text-purple-700 flex-shrink-0"
                    aria-hidden="true"
                  />
                )}
                <span
                  className={
                    index <= stepIndex
                      ? 'text-xs text-purple-800 dark:text-purple-200'
                      : 'text-xs text-purple-400 dark:text-purple-600'
                  }
                >
                  {step}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
